import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck, faCircleXmark} from '@fortawesome/free-solid-svg-icons';
export const ApprovedAndUnApprovedBtn = ({status, handleApprovedAndUnAprooved, statusId}) => {

    return(
        <React.Fragment>
           <div className="custom-button">
            { status === true ? <button className="approved-btn" onClick={() => handleApprovedAndUnAprooved(statusId)} ><FontAwesomeIcon icon={faCircleCheck} /> Approved</button>  : <button className="unapproved-btn" onClick={() => handleApprovedAndUnAprooved(statusId)}> <FontAwesomeIcon icon={faCircleXmark} /> Unapproved</button>  }            
           </div>
        </React.Fragment>
    )
}